var _style, _g, _g2, _g3, _g4, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeLobby(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9D9D9D;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 500,
    cy: 500,
    r: 500
  }))), /*#__PURE__*/React.createElement("image", {
    style: {
      display: "none",
      overflow: "visible"
    },
    width: 128,
    height: 128,
    xlinkHref: "home_lobby_pink_icon_.png",
    transform: "matrix(8.0859 0 0 8.0859 -23.9319 -7.15)"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M836.2,923.8c0,12.1-9.9,21.9-21.9,21.9H182.9c-12.1,0-21.9-9.9-21.9-21.9V543.9c0-6.1,2.6-12.1,7.2-16.2 l315.7-284.1c4.2-3.7,9.4-5.7,14.7-5.7c5,0,10.1,1.8,14.2,5.3l315.7,267.2c4.8,4.2,7.7,10.3,7.7,16.7V923.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M963.6,457.5l-64.2,71.2c-1.5,1.8-3.5,2.6-5.7,2.6c-1.8,0-3.7-0.7-5-2l-388-350.5l-388,350.3 c-1.5,1.3-3.5,2-5.5,2c-2,0-3.9-1.1-5.3-2.6l-64.2-71.2c-2.8-3.1-2.6-7.9,0.7-10.7l107.4-96.9V218.8c0-18,14.9-32.9,32.9-32.9H327 L493.8,35.3c2.8-2.6,7.2-2.6,10.3,0l459.3,411c1.5,1.3,2.4,3.3,2.6,5.3C965.8,454,965.1,456,963.6,457.5z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M570.2,916.2c-0.8-0.2-1.6-0.4-2.3-0.6c-22-6.5-44-13-66-19.5c-30.7-9.1-61.5-18.2-92.2-27.3 c-23.6-6.9-46.2-16.2-67.1-29.1c-57.8-35.8-96.8-86.2-117-151.2c-4.7-15.2-7.8-30.7-9.6-46.5c-1.1-9.5-1.7-19-1.7-28.6 c0-118.4,0-236.9,0-355.3c0-0.9,0-1.7,0-2.7c67.6,0,202.6,0,202.6,0s0.1,92.4,0.1,98c57-13.3,112.5-9.3,166.4,13.1 c37.8,15.7,70.2,39.1,97.2,69.9c26.7,30.4,45.5,65,56.4,104c32.4,116.4-18.1,230.9-103,289.2c-0.1,0-0.1-0.1-0.2-0.1 c0,0-0.1-0.1-0.1-0.1c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.4c0-123.1,0-246.3,0-369.4c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1-0.1-0.2 c-1.3-0.4-212.6-0.5-216.4-0.2c0,0.8,0,1.6,0,2.7c50.9,15.1,101.9,30.1,153,45.2C570.2,643.2,570.2,779.6,570.2,916.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeLobby);
export default __webpack_public_path__ + "static/media/home_lobby_.88a5a5d1.svg";
export { ForwardRef as ReactComponent };